import axios from 'axios';
import authHeader from './auth-header';
import UserHelper from '@/helpers/user.helper.js'

const API_URL = process.env.VUE_APP_API_URL + 'badge/';

class BadgeService {

    // À ajouter dans la classe BadgeService

    getBadges() {
        return axios.get(
            process.env.VUE_APP_API_URL +
            'clients/' + UserHelper.getClientId() + '/badges',
            { headers: authHeader() }
        );
    }

    getBadgeDetails(id) {
        return axios.get(
            process.env.VUE_APP_API_URL + 'badges/' + id,
            { headers: authHeader() }
        );
    }

    patchBadge(id, data) {
        return axios.patch(
            process.env.VUE_APP_API_URL + 'badges/' + id,
            data,
            { headers: authHeader() }
        );
    }

    addBadgeBalise(badgeId, baliseId) {
        return axios.put(
            process.env.VUE_APP_API_URL + `badges/${badgeId}/balises/${baliseId}`,
            {},
            { headers: authHeader() }
        );
    }

    removeBadgeBalise(badgeId, baliseId) {
        return axios.delete(
            process.env.VUE_APP_API_URL + `badges/${badgeId}/balises/${baliseId}`,
            { headers: authHeader() }
        );
    }

    // PROFILES

    getClientBadgeProfiles() {
        return axios.get(API_URL + 'getclientbadgeprofiles/' + UserHelper.getClientId(), { headers: authHeader() });
    }

    getProfile(id) {
        return axios.get(API_URL + 'getbadgeprofile/' + id, { headers: authHeader() });
    }

    createProfile(name) {
        return axios.put(API_URL + 'createclientbadgeprofile/' + UserHelper.getClientId(), {
            name: name
        },
            { headers: authHeader() });
    }

    updateProfile(data) {
        return axios.put(API_URL + 'updatebadgeprofile/' + UserHelper.getClientId(), data, { headers: authHeader() });
    }

    saveProfileBalises(id, data) {
        return axios.put(API_URL + 'updateprofilebalises/' + id, {
            balises: data
        },
            { headers: authHeader() });
    }

    deleteProfile(id) {
        return axios.delete(API_URL + 'deletebadgeprofile/' + id, { headers: authHeader() });
    }
}

export default new BadgeService();